<template>
<div :class="show_poster ? 'page page_artDetail page_limit' : 'page page_artDetail'">
    <div class="userInfo">
        <!-- 个人信息 -->
        <div class="user">
            <div class="top">
                <div class="user_info">
                    <div class="thumb">
                        <van-image class="thumb" fit="cover" :src="info.thumb ? ($publicData.withHttpStart(info.thumb) ? info.thumb : imageUrl+info.thumb) : $publicData.defaultTouxiang" :show-error="false" :show-loading="false" />
                    </div>
                    <span :class="register_status == 1 ? 'user_name zhuced' : 'user_name unzhuce'">{{ info.legal_person }}</span>
                </div>
                <!-- <div class="zhuli">助力</div> -->
				<div class="zhuli" @click="shareClick">分享</div>
				<div class="zhuli" style="margin-top: 1rem;" v-if="info.lntangible" @click="toMapFun">项目点</div>
            </div>
            <div class="info">
                <span class="user_name">{{ info.nickname }}</span>
                <span class="user_tag">{{ info.auth_company }}</span>
            </div>
            <!-- 线上结构 -->
            <div class="user_address" v-if="info.address">{{ info.address }}</div>
            <!-- 测试结构 -->
            <!-- <div class="user_address">
                <div class="text" v-if="livesInfo.tradesman">{{ livesInfo.tradesman.address }}</div>
            </div> -->
            <div class="acticons">
                <div class="action" @click="attentionClickFun">{{info.is_attention==1?'已关注':'关注'}}</div>
                <div class="action" @click="serveClick">私信</div>
				<!-- <div class="action">分享</div> -->
            </div>
            <div class="marsk">
                <div class="marsk_item" @click="toInfo">简介</div>
                <div class="marsk_item" v-if="info.nums" @click="toFans">粉丝{{'('+ info.nums.attentioner +')' }}</div>
                <!-- <div class="marsk_item">资质证明</div> -->
            </div>
        </div>
    </div>
    <!-- tab -->
    <van-tabs v-model="active" @change="changeTab" v-if="showGoods||showYueKan||showZixun||showTuji">
        <van-tab name="a" v-if="showGoods">
            <template #title>商品</template>
        </van-tab>
        <van-tab name="b" v-if="showYueKan">
            <template #title>约·看</template>
        </van-tab>
        <van-tab name="c" v-if="showZixun">
            <template #title>资讯</template>
        </van-tab>
        <van-tab name="d" v-if="showTuji">
            <template #title>图集</template>
        </van-tab>
    </van-tabs>
    <div class="no_data" v-if="showNoData">
        <img class="no_data_image" :src="publicPath + 'statics/images/no_data.png'" alt="" />
		<div class="no_data_title">{{noDataContent}}</div>
    </div>
    <!-- 商品 -->
    <div class="yuekan_con" v-if="active == 'a'">
        <div class="con_title" v-if="customade">
            <span class="title">定制</span>
            <img :src="publicPath+'statics/images/jiangren/icon_right.png'" alt="" class="icon_right" v-if="customadedata&&customadedata.length>0" @click="toArtDingzhi">
        </div>
        <div class="dinghzi" v-if="customade" @click="toDingzhiDetail">
            <van-image class="dingzhi_tu" fit="contain" :show-error="false" :show-loading="false" :src="customade.thumb ? imageUrl+customade.thumb : $publicData.intangibleDefault" />
            <div class="title">{{customade.title}}</div>
            <div class="price">价格￥<span class="real">{{customade.price_range}}</span></div>
            <div class="detail">{{customade.descript}}</div>
            <div class="tips" v-if="customade.customadingnum>0">
                <div class="tip">已定制</div>
                <div class="prowrap">
                    <van-progress :percentage="customade.percentage" :pivot-text="customade.customadednum+'件'" color="linear-gradient(-90deg, #DF3434, #FF5F34)" />
                    <div class="percent">{{customade.percentage}}%</div>
                </div>
            </div>
            <div class="dingzhi_time">
                <div class="times">
                    <div class="time" v-if="customade.endtime&&customade.endtime>0">
                        <div class="time_t">
                            {{customade.endtime}}
                        </div>
                        <div class="time_d">
                            距定制结束
                        </div>
                    </div>
                    <div class="time" v-if="customade.made_cycle&&customade.made_cycle>0">
                        <div class="time_t">
                            {{customade.made_cycle}}
                        </div>
                        <div class="time_d">
                            制作工期
                        </div>
                    </div>
                    <div class="time" v-if="customade.customadingnum&&customade.customadingnum>0">
                        <div class="time_t">
                            {{customade.customadingnum-customade.customadednum>0?customade.customadingnum-customade.customadednum:0}}
                        </div>
                        <div class="time_d">
                            剩余可定制
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="con_title" v-if="goodsList&&goodsList.length>0">
            <span class="title">商品</span>
        </div>
        <van-list v-model="loading_goods" :finished="finished_goods" finished-text="没有更多了" @load="getGoodsList" v-if="goodsList&&goodsList.length>0" :immediate-check="false">
            <div class="datalist">
                <ul class="list">
                    <li class="item" v-for="goods in goodsList" :key="goods.good_id" @click="toGoodsDetail(goods)">
                        <div :class="goods.is_blockchain ? 'thumb blockchain' : 'thumb'">
                            <!-- <img :src="goods.good_thumb ? goods.good_thumb : $publicData.intangibleDefault" alt=""> -->
                            <van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="goods.good_thumb ? imageUrl+goods.good_thumb : $publicData.intangibleDefault" />
                        </div>
                        <div class="item_xinxi">
                            <div class="title_wrap single">
                                <div class="title_tag">
                                    <span class="icon_self" v-if="goods.is_self">自营</span>
                                    <span class="icon_new" v-if="goods.is_new">最新</span>
                                </div>
                                <span v-if="goods.is_self && goods.is_new" class="title title1 slh_s"> {{ goods.good_title }}</span>
                                <span v-else-if="goods.is_self || goods.is_new" class="title title2 slh_s"> {{ goods.good_title }}</span>
                                <span v-else class="title title3 slh_s"> {{ goods.good_title }}</span>
                            </div>
                            <div class="info clearfix">
                                <div class="shop_name f-l slh_s">{{ goods.tradesman_name }}</div>
                                <div class="source f-r">{{ goods.place }}</div>
                            </div>
                            <div class="info">
                                <span class="f-l price">¥{{ goods.good_price }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </van-list>
    </div>
    <!-- 约看 -->
    <div class="yuekan_con" v-if="active == 'b'">
        <!-- 商家直播 -->
        <div class="type" v-if="livingInfo != null">
            <div class="con_title">
                <span class="title">商家直播</span>
            </div>
            <div class="yuekan" >
                <ul class="type_one_list">
                    <li class="item" @click="toLivingDetail(livingInfo)">
                        <div class="thumb">
                            <img :src="imageUrl+livingInfo.thumb" alt="">
                            <div class="tip">{{ livingInfo.status }}</div>
                        </div>
                        <div class="title">{{ livingInfo.title }}</div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 商家视频 -->
        <div class="type" v-if="videoInfo && videoInfo.length > 0">
            <div class="con_title">
                <span class="title">商家视频</span>
            </div>
            <div class="yuekan" >
                <ul class="type_two_list clearfix">
                    <li class="item f-l" v-for="video in videoInfo" :key="video.id" @click="goVideoDetail(video)">
                        <div class="thumb">
                            <img :src="imageUrl+video.thumb" alt="">
                        </div>
                        <div class="title slh_s">{{ video.title }}</div>
                        <div class="time">{{ video.created_at }}</div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 商家活动 -->
        <div class="type" v-if="livesInfo&&livesInfo.length>0">
            <div class="con_title">
                <span class="title">商家活动</span>
                <!-- <img :src="publicPath+'statics/images/jiangren/icon_right.png'" alt="" class="icon_right"> -->
            </div>
            <van-list v-model="loading_live" :finished="finished_live" finished-text="没有更多了" :immediate-check="false" @load="getLiveList">
                <div class="yuekan">
                    <ul class="type_three_list">
                        <li class="pro_item" v-for="lives in livesInfo" :key="lives.id" @click="goLivesDetail(lives)">
                            <div class="pro_item_l">
                                <img :src="imageUrl+lives.thumb" alt="" class="tu">
                            </div>
                            <div class="pro_item_r">
                                <div class="pro_item_r_t clearfix">
                                    <div class="title f-l slh">{{ lives.title }}</div>
                                    <div class="price f-r"><span class="tag_cash">¥</span>{{lives.price}}</div>
                                </div>
                                <div class="pro_item_r_b">
                                    <div class="info clearfix">
                                        <div class="info_l f-l">位置：</div>
                                        <div class="info_r f-l slh_s" v-if="lives.address">{{ lives.address }}</div>
                                    </div>
                                    <div class="info clearfix">
                                        <div class="info_l f-l">类型：</div>
                                        <div class="info_r f-l slh_s" v-if="lives.type">{{ lives.type.title }}</div>
                                    </div>
                                    <div class="info clearfix">
                                        <div class="info_l f-l">简介：</div>
                                        <div class="info_r slh f-l">{{ lives.describe }}</div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </van-list>
        </div>
    </div>
    <!-- 资讯 -->
    <div class="yuekan_con" v-if="active == 'c'">
        <!-- 头条 -->
        <div class="type" v-if="headLine && headLine.length > 0">
            <div class="con_title" >
                <span class="title">头条</span>
                <img :src="publicPath+'statics/images/jiangren/icon_right.png'" alt="" class="icon_right" v-if="headAllLine&&headAllLine.length>2" @click="toArtHead">
            </div>
            <div class="yuekan" >
                <ul class="type_head_list clearfix">
                    <li class="head_item" v-for="(item,index) in headLine" :key="index" @click="toHeadDetail(item)">
                        <van-image v-if="item.thumb" :src="item.thumb? imageUrl+item.thumb:defaultTouxiang" fit="cover" :show-error="false" :show-loading="false" class="head_tu"  />
                        <div v-else-if="item.images" class="tu_back">
                            <van-image v-for="(thumb,index) in item.images.split(',')" :key="index" :src="thumb?imageUrl+thumb:defaultTouxiang" fit="cover" :show-error="false" :show-loading="false" class="head_tu_2"  />
                        </div>
                        
                        <div class="head_title" >
                            {{ item.title }}
                        </div>
                        <div class="head_desc" >
                            {{ item.describe }}
                        </div>
                        <div class="head_time" >
                            {{ item.created_at }}
                        </div>
                        <div class="head_sep" v-if="index!=headLine.length-1">
                            
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 历史记忆-漂流瓶 -->
        <div class="type" v-if="lovedriftdata&&lovedriftdata.length>0">
            <div class="con_title">
                <span class="title">历史记忆</span>
            </div>
            <van-list v-model="loading_history" :finished="finished_history" :immediate-check="false" @load="getHistoryList" v-if="lovedriftdata&&lovedriftdata.length>0">
                <div class="datalist">
                    <div class="list">
                        <div class="item" v-for="(item,index) in lovedriftdata" :key="item.id">
                            <van-image :src="imageUrl+item.thumb" fit="cover" :show-error="false" :show-loading="false" class="tu" @click="goDetail(item)" />
                            <div class="" v-if="item.type == 2">
                                <div class="audio_wrap">
                                    <div :class="item.play ? 'audio_btn play' : 'audio_btn'" @click="audioState(item,index)"></div>
                                    <div class="progressbar">
                                        <div class="greenbar" :ref="'musicBar'+item.id"></div>
                                    </div>
                                    <div class="timetext">{{ item.time ? item.time : '00:00'}}</div>
                                </div>
                                <audio :ref="'player'+item.id" class="audio" :src="item.audio_url" />
                            </div>
                            <div class="title slh_s" @click="goDetail(item)">{{ item.title }}</div>
                            <div class="bottom">
                                <div class="user" @click="goDetail(item)">
                                    <van-image :src="item.user_thumb ? ($publicData.withHttpStart(item.user_thumb) ? item.user_thumb : imageUrl+item.user_thumb ) : $publicData.defaultTouxiang " fit="cover" :show-error="false" :show-loading="false" class="thumb" />
                                    <div class="name">{{ item.user_nickname ? item.user_nickname : '' }}</div>
                                </div>
                                <div class="like" @click="likeFun(item)">
                                    <img :src=" item.is_like ? publicPath+'statics/images/icon_liked_red.png' : publicPath+'statics/images/icon_like.png'" alt="" class="icon">
                                    <span :class="item.is_like ? 'nums liked' : 'nums'">{{ item.like_nums }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
        <div class="type" v-if="newsList && newsList.length > 0">
            <div class="con_title" >
                <span class="title">资讯</span>
            </div>
            <div class="yuekan" >
                <ul class="type_three_list clearfix">
                    <li class="item" v-for="news in newsList" :key="news.id" >
                        <div class="news" @click="toNewsDetail(news)">
                            {{ news.title }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="yuekan_con" v-if="active == 'd'">
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
        <div class="type" v-if="photoList&&photoList.length>0">
            <van-list >
                <div class="tu_list">
                    <div class="tu_item" v-for="photo in photoList" :key="photo.id">
                        <div class="date">{{photo.time}}</div>
                        <div class="image_back">
                            <van-image class="photo" fit="cover" :src="imageUrl+img.thumb" v-for="img in photo.attrs" :key="img.thumb" @click="toPhoto(img)"/>
                        </div>
                    </div>    
                </div>
            </van-list>
        </div>            
        <!-- </van-pull-refresh> -->
    </div>
	<!-- 分享海报 -->
	<van-overlay :show="show_poster" @click="show_poster = false" class="" />
	<div class="poster" v-if="show_poster">
		<img :src="imageUrl + posterUrl" alt="" class="posterTu">
	</div>
	<div class="share_tips" v-if="show_poster">长按保存图片</div>
	<!-- 入驻 -->
	<div class="ruzhu" v-if="register_status != 1" @click="toRegister">去入驻</div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
            type: this.$route.query.type,
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
            token: null,
            tradesmanId: this.$route.query.tradesmanId,
            active: this.$route.query.type ? this.$route.query.type : 'a',
            goodsList: [],  // 产品列表
            customadedata: [],
            customade: null,
            livesInfo: [],  // 活动列表
            videoInfo: [],  // 视频列表
            livingInfo: null,   // 直播
            lovedriftdata: [], // 漂流瓶
            photoList: [],
            headLine: [],
            headAllLine: [],
            imageUrl: this.$publicData.uploadImage,
            pages: {
                page: 1,
                size: 10
            },
            loading_goods: true, // 配置immediate-check="false"时, 初始值为true
            finished_goods: false,
            loading_live: true,
            finished_live: false,
            loading_history: true,
            finished_history: false,
            loading_photo: true, // 配置immediate-check="false"时, 初始值为true
            finished_photo: false,
			shareConfig: null, // 分享的相关配置
			show_poster: false, // 海报弹层
			posterUrl: null, // 分享图链接
			register_status: this.$route.query.register_status ? this.$route.query.register_status : 1, // 入驻状态 1 已入驻 0 未入驻
			is_tradesman: null, // 用户是否为匠人角色
            showGoods: false,
            showYueKan: false,
            showZixun: false,
            showTuji: false,
            showNoData: false,
            noDataContent: '',
        };
    },
    created: function () {
        // if (this.type == 'b') {
        //     this.active = 'b'
        // }
        console.log('this.active', this.active)
        var that = this
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                'data': {
                    'naviTitle': '匠人详情',
                    levitate: true,
                    showStatusBar: true,
                    // 'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            }
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                }
                this.getData()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            }) 
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
		}
		
    },
    mounted: function () {
        console.log('mounted')

    },
    activated: function () {
        console.log('activated')
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            
        } else {
            this.isClient = false
            // 获取列表
            if (this.tradesmanId != this.$route.query.tradesmanId) {
                this.token = this.$store.getters.token
                this.type = this.$route.query.type
                this.tradesmanId = this.$route.query.tradesmanId
                this.active = this.$route.query.type ? this.$route.query.type : 'a'
                this.pages = {
                    page: 1,
                    size: 10
                },
                this.posterUrl = null
                this.finished_goods = false
                this.finished_live = false,
                this.finished_photo = false,
                this.goodsList = []  // 产品列表
                this.livesInfo = []  // 活动列表
                this.videoInfo = []  // 视频列表
                this.headLine = []
                this.headAllLine = []
                this.livingInfo = null   // 直播
                this.photoList = []
                this.show_poster = false
                this.getData();
            }
            
		}
    },
    methods: {
        getData() {
            this.getDetail()
            this.getGoodsList()
            this.getLiveList()
            this.getHistoryList()
            this.getPhotoList()
        },
        setShowSet() {
            var count = 0
            if (this.customade || (this.goodsList&&this.goodsList.length>0)) {
                this.showGoods = true
                count++
            } else {
                this.showGoods = false
            }
            if (this.livingInfo != null || (this.videoInfo && this.videoInfo.length > 0) || (this.livesInfo && this.livesInfo.length>0)) {
                this.showYueKan = true
                count++
            } else {
                this.showYueKan = false
            }
            if ((this.lovedriftdata && this.lovedriftdata.length > 0) || (this.newsList && this.newsList.length > 0) || (this.headLine && this.headLine.length > 0)) {
                this.showZixun = true
                count++
            } else {
                this.showZixun = false
            }
            if (this.photoList && this.photoList.length > 0) {
                this.showTuji = true
                count++
            } else {
                this.showTuji = false 
            }
            if (this.showGoods == false && this.showYueKan == false && this.showZixun == false && this.showTuji == false) {
                this.showNoData = true
                this.noDataContent = '匠人还未有内容，敬请期待'
            } else {
                this.showNoData = false
            }
            if (count == 1) {
                if (this.showGoods) {
                    this.showYueKan = true
                    if (this.active == 'b') {
                        this.showNoData = true
                        this.noDataContent = '匠人还未有约 · 看，敬请期待'
                    }
                } else {

                    this.showGoods = true
                    if (this.active == 'a') {
                        this.showNoData = true
                        this.noDataContent = '匠人还未有商品，敬请期待'
                    }
                    // 
                }
            }
            // 匠人还未有约 · 看，敬请期待
        },
        shareClick() {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                console.log('shareClick')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.info.nickname ? that.info.nickname : that.$publicData.shareDefaultTitleA,
                        detail: that.info.describe ? that.info.describe : '',
                        url: url,
                        platFormType:'',
                        image: that.info.thumb ? that.$publicData.domain + that.info.thumb : that.$publicData.domain + that.$publicData.shareDefaultIcon
                    },
                };
                console.log('params:',params)
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })
            } else {
                this.show_poster = true
            }
            
        },
        
        getDetail() {
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId
            }
            this.$api.tradesman.detail(param).then(res => {
                if (res.code == 200) {
                    var info = res.result
					this.info = info
					this.register_status = res.result.register_status
					// 未入驻,先判断用户是否为匠人,非匠人方可让他去入驻
					if(this.register_status != 1){
						this.getUserInfo()
					}
                    // 调微信分享参数
					this.getShareData()
					// 获取分享图片
					this.getSharePoster()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        getHistoryList() {
            var that = this
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                page: 1,
			    size: 1000
            }
            this.$api.tradesman.history(param).then(res => {
                if (res.code == 200) {
                    that.headAllLine = []
                    that.headLine = []
                    for (let i = 0; i < res.result.headline.length; i++) {
                        const item = res.result.headline[i];
                        if (i < 2) {
                            that.headLine.push(item)
                        }
                        that.headAllLine.push(item)
                    }
                    that.newsList = res.result.list
                    var list = res.result.lovedriftdata
                    this.lovedriftdata = []
                    if (list && list.length > 0) {
						for (var i in list) {
							this.lovedriftdata.push(list[i])
						}
						this.pages.page++
						this.loading_history = false
                        this.finished_history = true
					} else {
						this.finished_history = true
					}
                    that.setShowSet()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 匠人下面对应的商品
        getGoodsList() {
            if (this.active != 'a') {
                return
			}
            var that = this
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.tradesman.goods(param).then(res => {
                if (res.code == 200) {
                    
                    if (res.result.customadedata && res.result.customadedata.length > 0) {
                        that.customadedata = res.result.customadedata
                        that.customade = res.result.customadedata[0]
                        that.customade.customadednum = that.customade.customadednum>0?that.customade.customadednum:0
                        that.customade.customadingnum = that.customade.customadingnum>0?that.customade.customadingnum:0
                        that.customade.percentage = (that.customade.customadednum*1/((that.customade.customadednum+that.customade.customadingnum*1)>0?(that.customade.customadednum+that.customade.customadingnum*1):100000)*100).toFixed(0)
                    } else {
                        that.customadedata = []
                        that.customade = null
                    }
                    var list = res.result.list.good
					if(list && list.length > 0){
						for (var i in list) {
							this.goodsList.push(list[i])
						}
						this.pages.page++
						this.loading_goods = false
					}else{
						this.finished_goods = true
					}
                    
                    console.log('this.goodsList', this.goodsList)
                } else {
                    this.finished_goods = true
                    // this.$toast(res.message)
                }
                that.setShowSet()
            })
        },
        // 匠人下面对应的约看 各活动
        getLiveList() {
            // if (this.active != 'b') {
            //     return
            // }
            var that = this
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.tradesman.lives(param).then(res => {
                if (res.code == 200) {
                    var list = [],videolist=[];
                    list = res.result.lives;
                    videolist = res.result.video;
                    if (this.pages.page == 1) {
                        this.livesInfo = []
                        this.videoInfo = []
                    }
                    for (var i in list) {
                        this.livesInfo.push(list[i])
                    }
                    for (var i in videolist) {
                        this.videoInfo.push(videolist[i])
                    }
                    this.livingInfo = (res.result.living != null && res.result.living.length > 0 ) ? res.result.living : null;
                    if ((list && list.length > 0) || (videolist && videolist.length > 0) ) {
                        this.pages.page++
                		this.loading_live = false
                    } else {
                        this.finished_live = true
                    }
                    // this.livesInfo = res.result
                    console.log('this.livesInfo', this.livesInfo)
                } else {
                    this.finished_live = true
                    // this.$toast(res.message)
                }
                that.setShowSet()
            })
        },
        getPhotoList() {
            var that = this
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId
            }
            this.$api.tradesman.photo(param).then(res => {
                if (res.code == 200) {
                    that.photoList = res.result
                } 
                that.setShowSet()
            })
        },
        serveClick() {
			var that = this;
			// 未入驻匠人不支持发私信
			if(that.register_status != 1){
				that.$toast('该匠人未入驻')
				return
			}
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo",memberParams,(data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        var params = {
                            token: this.token,
                            uuid: that.info.uuid
                        };
                        that.$api.xiaoxi.userInfo(params).then(res => {
                            if (res.code == 200) {
                                var tradesmanInfo = res.result;
                                // console.log('创建了与匠人的通信')
                                // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                                that.toAppServe(tradesmanInfo);
                            }
                        })
                    }
                });             
            } else {
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                    })
                    return
                }
                this.$router.push({
                    path: '/tradesman/chat',
                    query:{
                        uuid: this.info.uuid 
                    }
                })
                // this.$router.push({
                //     path: '/system/develop'
                // })
            }
        },
        toNewsDetail(news) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    'data': {
                        'url': news.link_url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                window.open(news.link_url)
            }
        },
        toAppServe(tradesmanInfo) {
            console.log('tradesmanInfo:',tradesmanInfo)
            var params = {
                data: {
                    toId: tradesmanInfo.im_username,
                    conversationId: tradesmanInfo.im_username,
                    toAvator: this.info.thumb,
                    toName: this.info.nickname,
                    toUUID: this.info.uuid,
                    toPhone: tradesmanInfo.tradesmans.data.phone,
                    trandsmanId: tradesmanInfo.tradesmans.id
                },
            }
            this.$bridge.callhandler("sdjy://public/chat",params,(data) => {

            });
        },
		// 关注匠人对app和h5进行判断
		attentionClickFun(){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.attentionClick();
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.attentionClick();
			}
		},
		// 关注匠人
        attentionClick() {
            var type = 1
            if (this.info.is_attention == 1) {
                type = 2
            }
            var params = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                type: type
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
                    if (this.info.is_attention == 1) {
                        this.$toast('取消关注成功')
                    } else {
                        this.$toast('关注成功')
                    }
                    this.getDetail()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        toInfo() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/info?tradesmanId=' + this.tradesmanId
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/info',
                    query: {
                        tradesmanId: this.tradesmanId
                    }
                })
            }
        },
        toFans() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/fans/index?tradesmanId=' + this.tradesmanId + '&tradesman_uuid=' + this.info.uuid
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/fans/index',
                    query: {
						tradesmanId: this.tradesmanId,
						tradesman_uuid: this.info.uuid
                    }
                })
            }
        },
        toHeadDetail(item) {
            this.$router.push({
				path: '/toutiao/detail',
				query: {
					headline_id: item.headline_id
				}
			})
        },
        // 漂流详情
        goDetail(item) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var url = this.$publicData.clientUrl + "/adrift/detail?drift_id=" + item.id
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                    (data) => {
                        if (data.code == 200) {
                            var params = {
                                data: {
                                    url: url
                                },
                            };
                            this.$bridge.callhandler(
                                "sdjy://public/openNewWebView",
                                params,
                                (data) => {}
                            );
                        }
                    }
                );
            } else {
                this.$router.push({
                    path: '/adrift/detail',
                    query: {
                        drift_id: item.id
                    }
                })
            }
        },
        toGoodsDetail(goods) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?goodsId=" + goods.good_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/shop/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/shop/detail',
                    query: {
                        goodsId: goods.good_id
                    }
                })
            }
        },
        toArtDingzhi() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var url = this.$publicData.clientUrl + '/art/dingzhi?tradesmanId=' + this.tradesmanId
                var params = {
                    'data': {
                        'url': url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/dingzhi',
                    query: {
                        tradesmanId: this.tradesmanId
                    }
                })
            }
        },
        toArtHead() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var url = this.$publicData.clientUrl + '/art/head?tradesmanId=' + this.tradesmanId
                var params = {
                    'data': {
                        'url': url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/head',
                    query: {
                        tradesmanId: this.tradesmanId
                    }
                })
            }
        },
        toDingzhiDetail() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var url = this.$publicData.clientUrl + '/dingzhi/detail?id=' + this.customade.id
                var params = {
                    'data': {
                        'url': url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/dingzhi/detail',
                    query: {
                        id: this.customade.id
                    }
                })
            }
        },
        toLivingDetail(living) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?id=" + living.living_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/zhibo/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: `/zhibo/detail`,
                    query:{id:living.living_id}
                })
            }
            
        },
        goVideoDetail(video) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?id=" + video.id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/video/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: `/video/detail`,
                    query:{id:video.id}
                })
            }
        },
        goLivesDetail(lives) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?id=" + lives.live_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/yuekan/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/yuekan/detail',
                    query: {
                        id: lives.live_id
                    }
                })
            }

        },
        toPhoto(photo) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?id=" + photo.thumb_id+'&tradesmanId='+this.tradesmanId+'&index='+photo.index
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/photo' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/photo',
                    query: {
                        id: photo.thumb_id,
                        tradesmanId: this.tradesmanId,
                        index: photo.index
                    }
                })
            }
        },
        // 切换 
        changeTab(name) {
            console.log('name', name)
            this.showNoData = false
            this.pages.page = 1
            if (name == 'a') {
                this.goodsList = []
                this.loading_goods = true;
                this.finished_goods = false;
                this.getGoodsList()
            } else if (name == 'b') {
                this.livesInfo = []
                this.loading_live = true;
                this.finished_live = false;
                this.getLiveList()
            } else if (name == 'c') {
                this.lovedriftdata = []
                this.headLine = []
                this.newsList = []
                this.loading_history = true;
                this.finished_history = false;
                this.getHistoryList()
            } else if (name == 'd') {
                this.photoList = []
                this.loading_photo = true;
                this.finished_photo = false;
                this.getPhotoList()
            }

        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.nickname ? that.info.nickname : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.info.describe ? that.info.describe : '', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.info.thumb ? (that.$publicData.withHttpStart(that.info.thumb) ? that.info.thumb : that.imageUrl+that.info.thumb)  : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
		},
		// 获取分享图片 ** 后台返回的
		getSharePoster(){
			var that = this
			var params = {
				id: that.info.uuid,
				type: 2 // 1商品 2匠人 3直播 4约看
			}
			that.$api.common.shareImg(params).then(res=>{
				if(res.code == 200){
					that.posterUrl = res.result
				}else{
                    that.posterUrl = null
					// that.$toast(res.message)
				}
			})
		},
		// 获取用户角色
		getUserInfo(){
			var params = {
                token: this.token,
                is_cloud: 0 // 非云订单
			}
			this.$api.user.index(params).then(res => {
				if (res.code == 200) {
					this.is_tradesman = res.result.info.userrole.is_tradesman
				}
			})
		},
		// 入驻
		toRegister(){
			var that = this
			if(that.is_tradesman){
				that.$toast('您已是匠人,不可重复申请')
				return
			}else{
				that.$router.push({
					path: '/cooperation/transition'
				})
			}
		},
		// 去查项目点
		toMapFun(){
			let that = this;
			localStorage.setItem("tradesmanId",this.tradesmanId)
			that.$router.push({
				path: "/map/index"
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
